module.exports = "<div id=\"http-loader\" *ngIf=\"isSpinnerVisible\">\r\n    <div class=\"loader-bg\">\r\n        <!-- material-line -->\r\n        <div class=\"sk-line-material\" [class.colored]=\"!backgroundColor\" *ngIf=\"spinner === Spinkit.skLine\">\r\n            <div class=\"sk-child sk-bounce1\" [style.background-color]='backgroundColor'></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/apostolos/Documents/globalrank/src/app/shared/spinner/spinner.component.html
// module id = ../../../../../src/app/shared/spinner/spinner.component.html
// module chunks = main